<template>
  <div class="physioDrugEdit">
    <el-dialog title="价格设置" :visible.sync="visible" width="960px" :close-on-click-modal="false"
      :close-on-press-escape="false" :destroy-on-close="true" :before-close="close">
      <div class="content" v-loading="loading">
        <el-form ref="form" class="form" :model="form" :rules="rules" label-width="120px">
          <div class="section">
            <div class="section_header">
              <div class="section_header_title">基本信息</div>
            </div>
            <div class="section_info">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="货号：">
                    <span class="section_text">{{ form.artNo }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="商品通用名称：">
                    <span class="section_text">{{ form.physioKindName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位：">
                    <span class="section_text">{{ form.unit }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="section">
            <div class="section_header">
              <div class="section_header_title">项目默认价格</div>
            </div>
            <div class="section_info">
              <el-row :gutter="20">
                <el-col :span="20">
                  <el-form-item label="定价方式：" prop="configType">
                    <el-radio-group v-model="form.configType" @change="configTypeChange">
                      <el-radio :label="1">固定价格</el-radio>
                      <el-radio :label="2">阶梯价格</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="20">
                  <el-form-item v-if="form.configType == 1" label="固定价格：" prop="fixedPrice">
                    <el-input class="w200" v-model="form.fixedPrice">
                      <template slot="append">元</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-if="form.configType == 2" label="阶梯价格：" prop="ladderPriceConfigs"
                    :rules="{ required: true }">
                    <div class="ladder_prices" v-if="form.ladderPriceConfigs.length > 0">
                      <div class="ladder_prices_item" v-for="(item, index) in form.ladderPriceConfigs" :key="index">
                        <el-form-item class="mr4" :prop="'ladderPriceConfigs.' + index + '.ladderStartNumber'"
                          :rules="validateLadderStartNumber(item, index)">
                          <el-input class="ladder_prices_item_number" placeholder="次数" :disabled="index == 0"
                            @input="val => item.ladderStartNumber = val.replace(/\D/g, '')"
                            v-model="item.ladderStartNumber"></el-input>
                        </el-form-item>
                        <div>——</div>
                        <el-form-item class="ml4" :prop="'ladderPriceConfigs.' + index + '.ladderEndNumber'"
                          :rules="validateLadderEndNumber(item)">
                          <el-input class="ladder_prices_item_number" placeholder="以上"
                            @input="val => item.ladderEndNumber = val.replace(/\D/g, '')"
                            v-model="item.ladderEndNumber"></el-input>
                        </el-form-item>
                        <el-form-item :prop="'ladderPriceConfigs.' + index + '.ladderPrice'" :rules="ladderPriceRule">
                          <el-input class="w200 ml12" placeholder="请输入" v-model="item.ladderPrice">
                            <template slot="append">元</template>
                          </el-input>
                        </el-form-item>
                        <div class="ladder_prices_delete" v-if="index > 1" @click="deleteLadderPriceConfigs(index)">删除
                        </div>
                      </div>
                      <div class="ladder_prices_btn" @click="addLadderPriceConfigs">+ 添加阶梯</div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="section">
            <div class="section_header">
              <div class="section_header_title">医生专属定价</div>
            </div>
            <div class="special_add mt20" @click="addDoctor">
              <span class="el-icon-plus special_add_icon"></span>
              <span class="special_add_text">添加医师</span>
            </div>
          </div>
          <div class="special_tips">当医生定价与项目默认价格不同时，可在此为特定医生单独设定价格</div>
          <div class="doctorPriceConfigs_table" v-if="form.doctorPriceConfigs && form.doctorPriceConfigs.length > 0">
            <el-table :data="form.doctorPriceConfigs" style="width: 100%" border>
              <el-table-column prop="doctorName" label="医生"></el-table-column>
              <el-table-column prop="configType" label="定价方式">
                <template slot-scope="scope">{{ scope.row.configType == 1 ? '固定定价' : '阶梯定价' }}</template>
              </el-table-column>
              <el-table-column label="专属价格">
                <template slot-scope="scope">
                  <div v-if="scope.row.configType == 1">
                    {{ scope.row.fixedPrice }}元/{{ form.executionMode == 10 ? '次' : '组' }}
                  </div>
                  <div v-if="scope.row.configType == 2">
                    <div v-for="item in scope.row.doctorLadderPriceConfigs">
                      <div v-if="item.ladderEndNumber">{{ item.ladderStartNumber }}-{{ item.ladderEndNumber
                        }}{{ form.executionMode == 10 ? '次' : '组' }}，{{ item.ladderPrice }}元/{{ form.executionMode == 10 ?
                        '次': '组'}}</div>
                      <div v-else>{{ item.ladderStartNumber }}{{ form.executionMode == 10 ? '次' : '组' }}以上，{{
                        item.ladderPrice }}元/{{ form.executionMode == 10 ? '次' : '组' }}</div>
                    </div>
                  </div>
                </template>

              </el-table-column>
              <el-table-column prop="effectTime" label="生效日期"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="handleEditDoctorPriceConfigs(scope.row, scope.$index)" type="text"
                    size="small">修改</el-button>
                  <el-button @click="handleDeleteDoctorPriceConfigs(scope.$index)" type="text"
                    size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="医生专属定价设置" :visible.sync="doctorVisible" width="540px" :close-on-click-modal="false"
      :close-on-press-escape="false" :destroy-on-close="true" :before-close="doctorClose">
      <div class="content">
        <el-form ref="doctorForm" class="form" :model="doctorPriceConfigs" :rules="doctorRules" label-width="100px">
          <el-form-item label="选择医生" prop="doctorId">
            <el-select v-model="doctorPriceConfigs.doctorId" :disabled="doctorPriceConfigsType == 'edit'"
              placeholder="选择医师" filterable @change="doctorChange">
              <el-option v-for="doctor in doctorOptions" :label="doctor.doctorName"
                :value="doctor.doctorId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="定价方式：" prop="configType">
            <el-radio-group v-model="doctorPriceConfigs.configType" @change="doctorConfigTypeChange">
              <el-radio :label="1">固定价格</el-radio>
              <el-radio :label="2">阶梯价格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="doctorPriceConfigs.configType == 1" label="固定价格：" prop="fixedPrice">
            <el-input class="w200" v-model="doctorPriceConfigs.fixedPrice">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="doctorPriceConfigs.configType == 2" label="阶梯价格：" prop="doctorLadderPriceConfigs"
            :rules="{ required: true }">
            <div class="ladder_prices" v-if="doctorPriceConfigs.doctorLadderPriceConfigs.length > 0">
              <div class="ladder_prices_item" v-for="(item, index) in doctorPriceConfigs.doctorLadderPriceConfigs"
                :key="index">
                <el-form-item class="mr4" :prop="'doctorLadderPriceConfigs.' + index + '.ladderStartNumber'"
                  :rules="validateDoctorLadderStartNumber(item, index)">
                  <el-input class="ladder_prices_item_number" placeholder="次数"
                    @input="val => item.ladderStartNumber = val.replace(/\D/g, '')"
                    v-model="item.ladderStartNumber"></el-input>
                </el-form-item>
                <div>——</div>
                <el-form-item class="ml4" :prop="'doctorLadderPriceConfigs.' + index + '.ladderEndNumber'"
                  :rules="validateLadderEndNumber(item)">
                  <el-input class="ladder_prices_item_number" placeholder="以上"
                    @input="val => item.ladderEndNumber = val.replace(/\D/g, '')"
                    v-model="item.ladderEndNumber"></el-input>
                </el-form-item>
                <el-form-item :prop="'doctorLadderPriceConfigs.' + index + '.ladderPrice'" :rules="ladderPriceRule">
                  <el-input class="w180 ml12" placeholder="请输入" v-model="item.ladderPrice">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
                <div class="ladder_prices_delete" v-if="index > 1" @click="deleteDoctorLadderPriceConfigs(index)">删除
                </div>
              </div>
              <div class="ladder_prices_btn" @click="addDoctorLadderPriceConfigs">+ 添加阶梯</div>
            </div>
          </el-form-item>
          <el-form-item label="生效日期：" prop="effectTime">
            <el-date-picker v-model="doctorPriceConfigs.effectTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="doctorClose">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="doctorSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { editDrugPriceConfigDetail } from '@/api/physio'
import { deepClone, isNull } from '@/utils/validateBase';
export default {

  data() {
    const validateEffectTime = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择生效日期'));
        return;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(value);
      selectedDate.setHours(0, 0, 0, 0);
      if (selectedDate < today) {
        callback(new Error('生效日期不能小于今天'));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      loading: false,
      form: {},
      rules: {
        'configType': [{ required: true, message: '请选择', trigger: 'change' }],
        'fixedPrice': [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的价格格式（最多两位小数）', trigger: 'blur' }
        ],
      },
      ladderEndNumberRule: [
        { required: true, message: '请输入', trigger: 'blur' },
      ],
      ladderPriceRule: [
        { required: true, message: '请输入', trigger: 'blur' },
        { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的价格格式（最多两位小数）', trigger: 'blur' }
      ],
      doctorVisible: false,
      doctorRules: {
        'doctorId': [{ required: true, message: '请选择', trigger: 'change' }],
        'configType': [{ required: true, message: '请选择', trigger: 'change' }],
        'fixedPrice': [{ required: true, message: '请输入', trigger: 'blur' }],
        'effectTime': [
          { required: true, message: '请选择', trigger: 'change' },
          { validator: validateEffectTime, trigger: 'change' }
        ],
      },
      doctorPriceConfigs: {
        doctorId: '',
        configType: '',
        doctorLadderPriceConfigs: [],
        fixedPrice: '',
        effectTime: ''
      },
      doctorOptions: [],
      doctorPriceConfigsIndex: '',
      doctorPriceConfigsType: '',
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        }
      }
    }
  },
  methods: {
    validateLadderStartNumber(item, index) {
      return [{
        validator: (rule, value, callback) => {
          if (isNull(item.ladderStartNumber)) {
            callback(new Error('不能为空'));
          } else {
            if (index == 0) {
              callback()
            } else {
              let lastItem = this.form.ladderPriceConfigs[index - 1]
              if (item.ladderStartNumber - 1 != lastItem.ladderEndNumber) {
                callback(new Error('请连续填写'));
              } else {
                callback()
              }
            }
          }
        },
        trigger: 'blur'
      }]
    },
    validateDoctorLadderStartNumber(item, index) {
      return [{
        validator: (rule, value, callback) => {
          if (isNull(item.ladderStartNumber)) {
            callback(new Error('不能为空'));
          } else {
            if (index == 0) {
              callback()
            } else {
              let lastItem = this.doctorPriceConfigs.doctorLadderPriceConfigs[index - 1]
              if (item.ladderStartNumber - 1 != lastItem.ladderEndNumber) {
                callback(new Error('请连续填写'));
              } else {
                callback()
              }
            }
          }
        },
        trigger: 'blur'
      }]
    },
    validateLadderEndNumber(item) {
      return [{
        validator: (rule, value, callback) => {
          if (isNull(item.ladderEndNumber)) {
            callback();
          } else {
            if (Number(item.ladderEndNumber) < Number(item.ladderStartNumber)) {
              callback(new Error('必须大于开始数字'));
            } else {
              callback()
            }
          }
        },
        trigger: 'blur'
      }]
    },
    deleteDoctorLadderPriceConfigs(index) {
      this.doctorPriceConfigs.doctorLadderPriceConfigs.splice(index, 1)
    },
    addDoctorLadderPriceConfigs() {
      let item = this.doctorPriceConfigs.doctorLadderPriceConfigs[this.doctorPriceConfigs.doctorLadderPriceConfigs.length - 1]
      this.doctorPriceConfigs.doctorLadderPriceConfigs.push({ ladderEndNumber: '', ladderPrice: '', ladderStartNumber: item.ladderEndNumber ? this.$bigNumber(item.ladderEndNumber, '+', 1) : '' })
    },
    handleEditDoctorPriceConfigs(row, index) {
      this.$getDoctorOptions()
      this.doctorPriceConfigsIndex = Number(index)
      this.doctorPriceConfigs = deepClone(row)
      this.doctorPriceConfigsType = 'edit'
      this.doctorVisible = true
    },
    handleDeleteDoctorPriceConfigs(index) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.form.doctorPriceConfigs.splice(index, 1)
        }).catch(() => {});
    },
    doctorSubmit() {
      this.$refs['doctorForm'].validate(async valid => {
        if (valid) {
          let doctorPriceConfigs = deepClone(this.doctorPriceConfigs)
          if (doctorPriceConfigs.configType == 1) {
            doctorPriceConfigs.doctorLadderPriceConfigs = []
          } else {
            doctorPriceConfigs.fixedPrice = ''
          }
          if (doctorPriceConfigs.configType == 2 && !isNull(doctorPriceConfigs.doctorLadderPriceConfigs[doctorPriceConfigs.doctorLadderPriceConfigs.length - 1].ladderEndNumber)) {
            return this.$message.error('阶梯价格设置需包含后续全部次数价格')
          }
          let index = this.form.doctorPriceConfigs.findIndex(v => { return v.doctorId == doctorPriceConfigs.doctorId })
          if (index > -1 && this.doctorPriceConfigsType == 'add') {
            return this.$message.error('同一医生，同一项目，仅能有1条专属定价')
          }
          if (this.doctorPriceConfigsType == 'add') {
            this.form.doctorPriceConfigs.push(doctorPriceConfigs)
          } else {
            this.$set(this.form.doctorPriceConfigs, this.doctorPriceConfigsIndex, doctorPriceConfigs)
          }
          this.$forceUpdate()
          this.doctorClose()
        }
      })
    },
    doctorConfigTypeChange(val) {
      if (val == 2 && this.doctorPriceConfigs.doctorLadderPriceConfigs.length == 0) {
        this.doctorPriceConfigs.doctorLadderPriceConfigs.push({ ladderEndNumber: '', ladderPrice: '', ladderStartNumber: 1 })
        this.doctorPriceConfigs.doctorLadderPriceConfigs.push({ ladderEndNumber: '', ladderPrice: '', ladderStartNumber: '' })
      }
    },
    doctorChange(val) {
      let item = this.doctorOptions.find(v => { return v.doctorId == val })
      this.doctorPriceConfigs.doctorId = val
      this.doctorPriceConfigs.doctorName = item.doctorName
    },
    doctorClose() {
      this.doctorVisible = false
      this.doctorPriceConfigsIndex = ''
      this.doctorPriceConfigsType = ''
      this.doctorPriceConfigs = {}
    },
    open(info) {
      this.visible = true
      this.form = deepClone(info)
      this.form.configType = isNull(info.configType) ? 1 : info.configType
      this.form.doctorPriceConfigs = isNull(info.doctorPriceConfigs) ? [] : info.doctorPriceConfigs
      this.form.ladderPriceConfigs = isNull(info.ladderPriceConfigs) ? [] : info.ladderPriceConfigs
    },
    close() {
      this.visible = false
      this.form = {}
    },
    addDoctor() {
      let form = deepClone(this.form)
      this.doctorPriceConfigs = {
        configType: form.configType,
        doctorId: '',
        doctorName: '',
        effectTime: '',
        fixedPrice: '',
        doctorLadderPriceConfigs: []
      }
      if (form.configType == 1) {
        this.doctorPriceConfigs.fixedPrice = form.fixedPrice
      } else if (form.configType == 2) {
        let doctorLadderPriceConfigs = []
        doctorLadderPriceConfigs.push({ ladderEndNumber: '', ladderPrice: '', ladderStartNumber: 1 })
        doctorLadderPriceConfigs.push({ ladderEndNumber: '', ladderPrice: '', ladderStartNumber: '' })
        this.doctorPriceConfigs.doctorLadderPriceConfigs = doctorLadderPriceConfigs
      }
      this.doctorPriceConfigsType = 'add'
      this.doctorVisible = true
      this.$getDoctorOptions()
    },
    configTypeChange(val) {
      if (val == 2 && this.form.ladderPriceConfigs.length == 0) {
        this.form.ladderPriceConfigs.push({ ladderEndNumber: '', ladderPrice: '', ladderStartNumber: 1 })
        this.form.ladderPriceConfigs.push({ ladderEndNumber: '', ladderPrice: '', ladderStartNumber: '' })
      }
    },
    addLadderPriceConfigs() {
      let item = this.form.ladderPriceConfigs[this.form.ladderPriceConfigs.length - 1]
      this.form.ladderPriceConfigs.push({ ladderEndNumber: '', ladderPrice: '', ladderStartNumber: item.ladderEndNumber ? this.$bigNumber(item.ladderEndNumber, '+', 1) : '' })
    },
    deleteLadderPriceConfigs(index) {
      this.form.ladderPriceConfigs.splice(index, 1)
    },
    submit() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          let params = deepClone(this.form)
          if (params.configType == 2 && !isNull(params.ladderPriceConfigs[params.ladderPriceConfigs.length - 1].ladderEndNumber)) {
            return this.$message.error('阶梯价格设置需包含后续全部次数价格')
          }
          this.loading = true
          delete params.updateTime
          delete params.createTime
          if (params.configType == 1) {
            params.ladderPriceConfigs = []
          } else {
            params.fixedPrice = ''
          }
          const res = await editDrugPriceConfigDetail(params)
          this.loading = false
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.close()
            this.$parent.getList()
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.physioDrugEdit /deep/ .el-dialog__header {
  padding: 12px 24px;
  border-bottom: 1px solid #E0E0E0 !important;
}

.physioDrugEdit /deep/ .el-dialog__title {
  font-weight: bold;
  font-size: 16px;
  color: #000000;
}

.physioDrugEdit /deep/ .el-dialog__headerbtn {
  top: 16px;
  right: 18px;
  height: 16px;
}

.physioDrugEdit /deep/ .el-dialog__body {
  padding: 0;
}

.physioDrugEdit /deep/ .el-dialog__footer {
  padding: 12px 16px;
}

.content {
  padding: 20px;
  max-height: 560px;
  overflow-x: hidden;
  overflow-y: auto;
}

.form {
  overflow: hidden;
}

.form /deep/ .el-form-item__label {
  line-height: 32px;
  color: #333333;
}

.form /deep/ .el-form-item__content {
  line-height: 32px;
}

.section {
  width: 100%;
}

.section_header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.section_header_title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.section_header_title::before {
  content: '';
  display: block;
  margin: 0 8px 0 0;
  width: 3px;
  height: 16px;
  background-color: #1890FF;
  border-radius: 2px;
}

.section_info {
  margin: 20px 0 0 0;
  width: 100%;
}

.form_time {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.form_time_unit {
  flex-shrink: 0;
  margin: 0 0 0 8px;
  font-size: 14px;
  color: #333333;
}

.special_label_item {
  margin-bottom: 0px;
}

.special_add {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  width: fit-content;
  height: 32px;
  background-color: #FFFFFF;
  border: 1px solid #1890FF;
  border-radius: 2px;
  cursor: pointer;
}

.special_add_icon {
  font-size: 14px;
  color: #1890FF;
}

.special_add_text {
  margin: 0 0 0 4px;
  font-size: 14px;
  color: #1890FF;
}

.special_tips {
  margin: 4px 0 0 0;
  line-height: 22px;
  font-size: 12px;
  color: #999999;
}

.special_list {
  box-sizing: border-box;
  margin: 8px 0 0 0;
  padding: 12px 16px;
  width: 610px;
  background-color: #F5F7FA;
}

.special_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.special_item+.special_item {
  margin: 16px 0 0 0;
}

.special_item_left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.special_item_form_item {
  margin-bottom: 0px;
  width: 140px;
}

.special_item_form_item+.special_item_form_item {
  margin-left: 12px;
}

.special_item_form_unit {
  margin: 0 0 0 8px;
  font-size: 14px;
  color: #333333;
}

.special_item_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.pecial_item_btn {
  line-height: 22px;
  font-size: 14px;
  color: #808080;
  cursor: pointer;
}

.ladder_prices {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ladder_prices_item {
  display: flex;
  align-items: center;
}

.ladder_prices_item_number {
  width: 60px;
}

.ladder_prices_item_number /deep/.el-input__inner {
  padding: 0;
  text-align: center;
}

.ladder_prices_btn {
  width: 100px;
  font-weight: 400;
  font-size: 14px;
  color: #1890FF;
  cursor: pointer;
}

.ladder_prices_delete {
  line-height: 22px;
  font-size: 14px;
  color: #808080;
  cursor: pointer;
  margin-left: 16px;
}

.doctorPriceConfigs_table {
  margin-top: 16px;
}
</style>